import Footer from "../../components/layout/Footer";
import Navbar from "../../components/nav/Navbar";
import DifferentiatorSection from "./sections/differentiator/DifferentiatorSection";
import FAQSection from "./sections/faq/FAQSection";
import FeaturesSection from "./sections/features/FeaturesSection";
import FinalCTASection from "./sections/final-cta/FinalCTASection";
import HeroSection from "./sections/hero/HeroSection";
import HowItWorksSection from "./sections/how-it-works/HowItWorksSection";
import PricingSection from "./sections/pricing/PricingSection";
import ProSection from "./sections/pro/ProSection";
import ShowcaseSection from "./sections/showcase/ShowcaseSection";
export default function LandingPage() {
    return (
        <>
            <Navbar />
            <HeroSection />
            <ShowcaseSection />
            <HowItWorksSection />
            <DifferentiatorSection />
            <ProSection />
            <PricingSection />
            <FAQSection />
            <FinalCTASection />
            <Footer />
        </>
    )
}
